function createCookie(configs) {
  const {
    cName, cValue, expires, path, domain, secure, encode = true, samesite,
  } = configs;
  const value = encode ? encodeURIComponent(cValue) : cValue;

  return [
    `${cName}=${value}`,
    expires ? `expires=${expires.toUTCString()}` : '',
    path ? `path=${path}` : '',
    domain ? `domain=${domain}` : '',
    secure ? 'secure' : '',
    samesite ? `samesite=${samesite}` : '',
  ].filter(item => !!item).join('; ');
}

function set(cName, cValue, expires, path, domain, secure, samesite) {
  document.cookie = createCookie({
    cName,
    cValue,
    expires,
    path,
    domain,
    secure,
    encode: true,
    samesite,
  });
}

function get(cName, skipDecode) {
  const ARRcookies = document.cookie.split('; ');

  for (let i = 0; i < ARRcookies.length; i += 1) {
    let x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
    const y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
    x = x.replace(/^\s+|\s+$/g, '');
    if (x === cName) {
      // Use case: ImportFileSaSUrl is only valid with specific arguments containing encoded html
      // But some portions of the Url with encodable characters are not encoded
      // (e.g. &arg_name=.....)
      // It would be impossible to re-encode the Url
      // after getting from cookie b/c body of an argument
      // could contain some of the characters that should get encoded
      if (skipDecode) {
        return y;
      }
      return decodeURIComponent(y);
    }
  }

  return null;
}

module.exports = { createCookie, set, get };
